export const SET_USER = "SET_USER";
export const GET_ERRORS = "GET_ERRORS";
export const RESET_ERRORS = "RESET_ERRORS";
export const SAVE_ACCESS = "SAVE_ACCESS";
export const REMOVE_ACCESS = "REMOVE_ACCESS";
export const LOGOUT = "LOGOUT";
